import ToggleButton from './ToggleButton';
import ToggleButtonContainer from './ToggleButtonContainer';

/**
 * 라욷드 토글 버튼
 */
export default Object.assign(ToggleButton, {
  Container: ToggleButtonContainer,
});
